module.exports = __webpack_public_path__ + "img/06-3.1f14bd44.png";